<template>
  <div>

    <navbar></navbar>

    <div class="bg-header-straight-medium">
      <div class="container">
        <h1>{{ nonEmptyCarts.length > 1 ? 'Warenkörbe' : 'Warenkorb' }}</h1>
      </div>
    </div>

    <div class="container" v-if="nonEmptyCarts.length < 1">
      <p class="font-large text-black italic">Du hast keine offenen Warenkörbe</p>
    </div>

    <div v-if="loadingCarts" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true"></cg-loader>
      </div>
    </div>

    <div class="container-full" v-for="cart in nonEmptyCarts" >
      <div class="card table-card">
        <div class="text">
          <h3>{{ cart.shop.name + formatType(cart.type) }} vom {{ formatDate(cart.updated_at) }}</h3>
          <h4 v-if="cart.shop.min_order_value > 0" >Mindesbestellwert: {{ getOrderPrice(cart.shop.min_order_value, cart.shop) }}</h4>
          <table class="cart">
            <thead>
              <tr>
                <th>Menge</th>
                <th>Einheit</th>
                <th class="name">Artikel</th>
                <th>Preis (brutto)</th>
                <th class="sm:hidden md:hidden">Netto-Summe</th>
                <th class="sm:hidden md:hidden">MwSt-Satz</th>
                <th>Brutto-Summe</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in cart.cartItems.data" :class="[loading && currentRow === item.uid ? 'opacity-50' : '']">
                <td data-label="Menge" v-if="cart.type === 'catalog'">
                  <div class="form-field number">
                    <button @click.prevent="decreaseAmount(cart, item)" class="btn number-left">-</button>
                    <input
                        type="number"
                        :value="loading && currentRow === item.uid ? amount : item.amount"
                        :min="1"
                        :max="getMaxForItem(item)"
                        @change="setAmount(cart, item, $event)"
                        class="height50"
                    />
                    <button @click.prevent="increaseAmount(cart, item)" class="btn number-right">+</button>
                  </div>
                </td>
                <td data-label="Menge" v-if="cart.type === 'live'">{{ item.amount }}</td>
                <td data-label="Einheit">{{ getAmountLabel(item.unit) }}</td>
                <td data-label="Artikel">{{ item.name }}</td>
                <td data-label="Preis (brutto)">{{ formatPrice(item, 'unit') + ' / ' + getTextFromUnit(item.unit) }}</td>
                <td class="netto-summe sm:hidden md:hidden">{{ formatPrice(item, 'nettoSum') }}</td>
                <td class="mwst-satz sm:hidden md:hidden">{{ item.tax_percent + '%' }}</td>
                <td data-label="Brutto-Summe">{{ formatPrice(item, 'bruttoSum') }}</td>
                <td data-label="Entfernen">
                  <span
                    v-if="cart.type === 'catalog'"
                    @click.prevent="removeItem(cart, item)"
                    class="text-cg-error cursor-pointer">
                    <icon name="times"></icon>
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total sm:hidden md:hidden">
                <td colspan="6">Gesamtsumme (inkl. MwSt):</td>
                <td>{{ totalPriceFormat(cart) }}</td>
                <td></td>
              </tr>
              <tr class="total lg:hidden">
                <td colspan="3">Gesamtsumme (inkl. MwSt):</td>
                <td colspan="2" class="text-right">{{ totalPriceFormat(cart) }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
          <div :class="['buttons', cart.type === 'catalog' ? 'justify-between' : 'justify-end']">
            <button
              v-if="cart.type === 'catalog'"
              :class="['btn orange mr-4', loading && currentShop === cart.shop.uid ? 'opacity-50' : '']"
              @click.prevent="deleteCart(cart)">Warenkorb löschen
            </button>
            <button
              :class="['btn green', ((loading && currentShop === cart.shop.uid) || !canCheckout(updatingCart, cart)) ? 'opacity-50' : '']"
              @click.prevent="submitCart(cart)">Zur Kasse gehen
          </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container"  >
      <product-slider :title="'Das könnte Dir auch gefallen'" :products="productList" :type="'teaser'" ></product-slider>
    </div>

    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import CgFooter from '../components/CgFooter.vue'
  import CgLoader from '../components/menus/cgLoader'

  import { mapGetters, mapActions } from 'vuex'
  import formatting from '@/mixins/formatting.js'
  import ProductSlider from '../components/slider/productSlider'

  export default {
    name: 'Cart',
    components: {
      ProductSlider,
      CgLoader,
      'navbar': Navbar,
      'cgfooter': CgFooter
    },
    mixins: [formatting],
    mounted () {
      var self = this
      this.getCarts({
        user: this.account.uid,
        cb () {
          self.loadingCarts = false
        },
        errorCb () {
          self.loadingCarts = false
        }
      })
    },
    created () {
      this.getProductList()
    },
    data () {
      return {
        amount: 0,
        currentRow: null,
        currentShop: null,
        loadingCarts: true,
        saveToast: null,
        updatingCart: false
      }
    },
    methods: {
      ...mapActions([
        'getCarts',
        'getProductList',
        'updateItemFromCart',
        'deleteItemFromCart',
        'deleteActiveCart',
        'getShopProduct'
      ]),
      getStepForItem (item) {
        return this.getStepAmount(item.product.unit)
      },
      decreaseAmount (cart, item) {
        var step = this.getStepForItem(item)
        var min = this.getStepAmount(item.unit)
        this.amount = (item.amount - step) < min ? item.amount : (item.amount - step)
        if (this.amount !== item.amount) {
          this.updateAmount(cart, item, this.amount)
        }
      },
      increaseAmount (cart, item) {
        var step = this.getStepForItem(item)
        this.amount = (item.amount + step) > this.getMaxForItem(item) ? item.amount : (item.amount + step)
        if (this.amount !== item.amount) {
          this.updateAmount(cart, item, this.amount)
        } else {
          this.updateStockInfo(item)
        }
      },
      setAmount (cart, item, e) {
        this.currentRow = item.uid
        var min = this.getStepAmount(item.unit)
        this.amount = e.target.value
        if (isNaN(this.amount) || this.amount < min) {
          this.amount = this.getStartAmount(item.unit)
        } else {
          this.amount = Math.floor(this.amount)
        }
        if (this.amount <= this.getMaxForItem(item) && this.amount >= min) {
          this.updateAmount(cart, item, this.amount)
        } else {
          if (this.amount > this.getMaxForItem(item)) {
            this.updateStockInfo(item)
          }
          e.target.value = item.amount
        }
      },
      updateAmount (cart, cartItem, amount) {
        this.updatingCart = true
        this.currentRow = cartItem.uid
        this.currentShop = cart.shop.uid
        var vm = this
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
            theme: 'primary',
            position: 'top-right',
            icon: 'info',
            duration: 10000
          })
          vm.updateItemFromCart({
            cart: cart,
            shop: cart.shop.uid,
            user: vm.account.uid,
            item: cartItem.uid,
            amount: {amount},
            cb: () => {
              vm.updatingCart = false
              vm.$toasted.success(cartItem.name + ' wurde aktualisiert.', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                action: {
                  text: 'X',
                  class: 'toastBtn',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
                icon: 'check'
              })
              vm.activeAmount = ''
              vm.saveToast.goAway(100)
              vm.saveToast = null
            },
            errorCb: (error) => {
              vm.updatingCart = false
              if (cartItem.product && error.response && error.response.status === 406) {
                vm.updateStockInfo(cartItem)
              } else {
                vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'close'
                })
              }
              vm.saveToast.goAway(100)
              vm.saveToast = null
            }
          })
        }
      },
      updateStockInfo (cartItem) {
        var vm = this
        vm.getShopProduct({
          product: cartItem.product.uid,
          cb (response) {
            var message = response.current_stock > 0 ? 'Von diesem Produkt gibt es aktuell nur ' + response.current_stock + ' ' + vm.getAmountLabel(response.unit) + ' zu Verfügung.' : 'Dieses Produkt steht aktuell nicht zu Verfügung.'
            vm.$toasted.error(message, {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'close'
            })
          },
          errorCb () {
            vm.$toasted.error('Dieses Produkt ist aktuell nicht in der gewünschten Menge vorrätig.', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'close'
            })
          }
        })
      },
      removeItem (cart, cartItem) {
        this.updatingCart = true
        var vm = this
        if (!vm.saveToast) {
          vm.$dialog.confirm('Möchtest Du diesen Artikel entfernen?').then(() => {
            vm.saveToast = vm.$toasted.info('Wird gelöscht...', {
              theme: 'primary',
              duration: 10000,
              position: 'top-right',
              icon: 'info'
            })
            vm.deleteItemFromCart({
              cart: cart,
              shop: cart.shop.uid,
              user: vm.account.uid,
              item: cartItem.uid,
              cb: () => {
                vm.updatingCart = false
                vm.$toasted.success(cartItem.name + ' wurde aus dem Warenkorb entfernt.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              },
              errorCb: () => {
                vm.updatingCart = false
                vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'close'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              }
            })
          }).catch(() => {
          })
        }
      },
      deleteCart (cart) {
        var vm = this
        vm.updatingCart = true
        if (!vm.saveToast) {
          vm.$dialog.confirm('Möchtest Du diesen Warenkorb löschen?').then(() => {
            vm.saveToast = vm.$toasted.info('Wird gelöscht...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
            vm.deleteActiveCart({
              cart: cart,
              shop: cart.shop.uid,
              user: vm.account.uid,
              cb: () => {
                vm.updatingCart = false
                vm.$toasted.success('Der Warenkorb wurde gelöscht.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              },
              errorCb: () => {
                vm.updatingCart = false
                vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'close'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              }
            })
          }).catch(() => {
          })
        }
      },
      submitCart (cart) {
        if (this.canCheckout(this.updatingCart, cart)) {
          this.$router.push({name: 'checkout', params: {'cart': cart.uid}})
        } else {
          this.$toasted.error('Der Mindesbestellwert ist für diesen Shop ist ' + this.getOrderPrice(cart.shop.min_order_value, cart.shop), {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
        }
      }
    },
    computed: {
      nonEmptyCarts () {
        var resultingCarts = []
        for (var c in this.carts.data) {
          if (this.carts.data[c].cartItems.data.length) {
            resultingCarts.push(this.carts.data[c])
          }
        }
        return resultingCarts
      },
      ...mapGetters({
        authenticated: 'auth_is_authenticated',
        account: 'auth_get_account',
        carts: 'user_get_carts',
        loading: 'options_is_loading',
        productList: 'product_get_list'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Cart.vue